import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';

    interface Props {
        className?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'NoCompany',
  props: {
    className: {}
  },
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 120 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className)
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M34.4336 29.6689V90.1914H82.5371V68.3164L87.5371 72.333V90.1914H93.5117C95.0752 90.1913 96.5875 89.5546 97.7129 88.4004C98.8405 87.2439 99.4854 85.6622 99.4854 84V81.9326L104.334 85.8281C103.965 88.1022 102.915 90.227 101.293 91.8906C99.2402 93.996 96.4428 95.1913 93.5117 95.1914H23.459C20.5272 95.1913 17.7293 93.9949 15.6768 91.8877C13.6263 89.7825 12.4854 86.9407 12.4854 83.9912V57.8916C12.4854 54.9421 13.6263 52.1003 15.6768 49.9951C17.7293 47.8879 20.5272 46.6915 23.459 46.6914H29.4336V25.6514L34.4336 29.6689ZM23.459 51.6914C21.8963 51.6915 20.3834 52.3287 19.2578 53.4844C18.1302 54.6423 17.4854 56.2265 17.4854 57.8916V83.9912C17.4854 85.6563 18.1302 87.2405 19.2578 88.3984C20.3834 89.5541 21.8963 90.1913 23.459 90.1914H29.4336V51.6914H23.459ZM66.959 73.2432C68.3396 73.2432 69.4589 74.3625 69.459 75.7432C69.459 77.1239 68.3397 78.2432 66.959 78.2432H50.0117C48.631 78.2432 47.5117 77.1239 47.5117 75.7432C47.5118 74.3625 48.6311 73.2432 50.0117 73.2432H66.959ZM76.1865 3.19141C79.1832 3.19141 82.0654 4.36149 84.1973 6.45703C86.3305 8.554 87.5371 11.4072 87.5371 14.3916V33.6982H93.5117C96.4426 33.6984 99.2402 34.8928 101.293 36.998C103.344 39.1014 104.485 41.9417 104.485 44.8896V75.6885L99.4854 71.6709V44.8896C99.4854 43.2275 98.8405 41.6458 97.7129 40.4893C96.5875 39.335 95.0753 38.6983 93.5117 38.6982H87.5371V62.0713L82.5371 58.0547V14.3916C82.5371 12.7612 81.8787 11.1886 80.6924 10.0225C79.5046 8.8549 77.8845 8.19141 76.1865 8.19141H40.7842C39.0862 8.19141 37.4661 8.8549 36.2783 10.0225C35.092 11.1886 34.4336 12.7612 34.4336 14.3916V19.4072L29.4336 15.3896V14.3916C29.4336 11.4072 30.6402 8.554 32.7734 6.45703C34.9053 4.36149 37.7875 3.19141 40.7842 3.19141H76.1865ZM69.4512 57.8037C69.3791 59.1198 68.2931 60.165 66.959 60.165H50.0117C48.631 60.165 47.5117 59.0457 47.5117 57.665C47.5119 56.2845 48.6311 55.165 50.0117 55.165H66.168L69.4512 57.8037ZM51.2969 43.2178H50.0117C48.6311 43.2178 47.5119 42.0983 47.5117 40.7178C47.5117 40.5462 47.5286 40.3786 47.5615 40.2168L51.2969 43.2178ZM66.959 38.2178C68.3397 38.2178 69.459 39.3371 69.459 40.7178C69.4588 42.0983 68.3396 43.2178 66.959 43.2178H64.0693L57.8467 38.2178H66.959ZM66.959 20.1396C68.3397 20.1396 69.459 21.2589 69.459 22.6396C69.4589 24.0203 68.3396 25.1396 66.959 25.1396H50.0117C48.6311 25.1396 47.5118 24.0203 47.5117 22.6396C47.5117 21.2589 48.631 20.1396 50.0117 20.1396H66.959Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("line", {
      x1: "3.51471",
      y1: "3.42547",
      x2: "116.617",
      y2: "94.2939",
      stroke: "currentColor",
      "stroke-width": "5",
      "stroke-linecap": "round"
    }, null, -1)
  ]), 2))
}
}

})